import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-area-details',
  templateUrl: './area-details.component.html',
  styleUrl: './area-details.component.scss'
})
export class AreaDetailsComponent {
  constructor(public route: Router, private location: Location) {}
  goBackToPrevPage(): void {
    if(this.route.url == '/' || this.route.url == '/dashboard') {
      return
    }
    else{
      this.location.back();
    }
  }
}
